import styles from './styles';

import * as React from 'react';

import { computed } from 'mobx';
import { inject, observer } from 'mobx-react';

import type { WithStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core';

import FieldSelect from 'bz-core-controls/controls/form/field/field-select';
import Button from 'bz-core-controls/controls/general/button';

import { Button as ClickButton } from 'click-controls';
import ClickSelect from 'click-controls/controls/form/field/field-select';
import { cache } from 'tm3-core/cache';
import HideFrom from 'tm3-core/controls/hideFrom';
import ShowFor from 'tm3-core/controls/showFor';
import { IsProduct } from 'tm3-core/enums/product-enum';
import type TerminalPaymentDialogStore from './stores/terminal-payment-dialog-store';

interface IProps extends WithStyles<typeof styles> {
  terminalPaymentDialogStore?: TerminalPaymentDialogStore;
}
@inject('terminalPaymentDialogStore')
@observer
class TerminalPaymentDeviceSelect extends React.Component<IProps> {
  render() {
    const { terminalPaymentDialogStore, classes } = this.props;
    if (!this.show) {
      return null;
    }

    const buttonClass = !cache.isClick ? classes.buttons : '';
    return (
      <div className={classes.container}>
        {this.noTerminals ? (
          <p>
            You have no terminals setup at this location. Please navigate to Settings &gt; Finances
            &gt; Integrations to set one up.
          </p>
        ) : (
          <>
            <ShowFor product={IsProduct.Click}>
              <ClickSelect
                label={'Terminal'}
                displayMember="name"
                valueMember="id"
                items={terminalPaymentDialogStore!.clickTerminalDropdownItems}
                value={terminalPaymentDialogStore!.selectedTerminalId}
                onChange={terminalPaymentDialogStore!.onTerminalChange}
              />
            </ShowFor>
            <HideFrom products={[IsProduct.Click]}>
              <FieldSelect
                label={'Terminal'}
                includeNone={false}
                items={terminalPaymentDialogStore!.terminalDropdownItems}
                value={terminalPaymentDialogStore!.selectedTerminalId}
                onChange={terminalPaymentDialogStore!.onTerminalChange}
              />
            </HideFrom>
          </>
        )}
        <div className={buttonClass}>
          <ShowFor product={IsProduct.Click}>
            <ClickButton className={'btn mr-2'} onClick={terminalPaymentDialogStore!.onCancel}>
              Cancel
            </ClickButton>
            <ClickButton
              onClick={terminalPaymentDialogStore!.onRequestPayment}
              disabled={!terminalPaymentDialogStore!.selectedTerminalId}
            >
              Send Payment To Terminal
            </ClickButton>
          </ShowFor>

          <HideFrom products={[IsProduct.Click]}>
            <Button flat={true} onClick={terminalPaymentDialogStore!.onCancel}>
              Cancel
            </Button>
            <Button
              onClick={terminalPaymentDialogStore!.onRequestPayment}
              disabled={!terminalPaymentDialogStore!.selectedTerminalId}
            >
              Send Payment To Terminal
            </Button>
          </HideFrom>
        </div>
      </div>
    );
  }

  @computed
  private get noTerminals(): boolean {
    const { terminalPaymentDialogStore } = this.props;
    if (cache.isClick) {
      terminalPaymentDialogStore!.clickTerminalDropdownItems.length === 0;
    }
    return terminalPaymentDialogStore!.terminalDropdownItems.length === 0;
  }

  @computed
  private get show(): boolean {
    const { terminalPaymentDialogStore } = this.props;
    return (
      terminalPaymentDialogStore!.loaded &&
      !terminalPaymentDialogStore!.isProcessing &&
      !terminalPaymentDialogStore!.paymentError
    );
  }
}

export default withStyles(styles)(TerminalPaymentDeviceSelect);
